import { render, staticRenderFns } from "./kupitvin.vue?vue&type=template&id=3a5ab36b&scoped=true&"
import script from "./kupitvin.vue?vue&type=script&lang=js&"
export * from "./kupitvin.vue?vue&type=script&lang=js&"
import style0 from "./kupitvin.vue?vue&type=style&index=0&id=3a5ab36b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ab36b",
  null
  
)

export default component.exports